import React from "react";
import useSchool from "../../modules/game/hooks/use-school";
import './style.scss'

type Props = {
    schoolId: SchoolId,
    onSelected: (id: SchoolId) => void,
    used?: boolean,
    onClick: (id: SchoolId) => void
}

const Answer: React.FunctionComponent<Props> = ({ schoolId, onSelected, used, onClick }) => {

    const { school } = useSchool(schoolId);

    return (
        <div className="answer-wrapper">
            <div className="answer-wrapper-2">
                <div className={`answer ${used ? 'used' : ''}`} onClick={() => onClick(schoolId)}>
                    {school && <>
                        <div>
                            <p>{school.name}</p>
                        </div>
                    </>}
                </div>
            </div>
        </div>
    )
}

export default Answer;
